import { render, staticRenderFns } from "./AcademyNoticeDetail.vue?vue&type=template&id=64e64eab&scoped=true&lang=pug&"
import script from "./AcademyNoticeDetail.vue?vue&type=script&lang=ts&"
export * from "./AcademyNoticeDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e64eab",
  null
  
)

export default component.exports